import MapViewPage from 'pages/MapView'

export const MapViewRoot = {
  key: 'MapViewRoot',
  label: 'MapView',
  path: '/',
  element: (
    <MapViewPage />
  ),
  defaultPath: '/',
  trackingName: 'MapView',
}
